module.exports = __webpack_public_path__ + "static/media/myJam-entry.2cbba453.png";